export function DashboardPage() {
  return (
    <div className="rounded-xl border border-border-subtle bg-surface-1 p-6">
      <h1 className="text-base font-semibold">Deployments</h1>
      <p className="mt-1 text-sm text-text-secondary">
        No deployments yet. This page is a placeholder for the deployment server console.
      </p>
    </div>
  );
}
